import { type VariantProps } from 'class-variance-authority';
import { LoaderCircle } from 'lucide-react';
import { type ComponentProps } from 'react';

import { cx } from '@/lib/cx';

import { estiloBotao } from './estilos';

export type ButtonProps = ComponentProps<'button'> &
  VariantProps<typeof estiloBotao> & {
    /** Mostra o indicador e bloqueia o clique enquanto a ação roda. */
    carregando?: boolean;
  };

export function Button({
  className,
  variante,
  tamanho,
  carregando = false,
  disabled,
  children,
  type = 'button',
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      className={cx(estiloBotao({ variante, tamanho }), className)}
      disabled={disabled === true || carregando}
      aria-busy={carregando || undefined}
      {...props}
    >
      {carregando && <LoaderCircle className="animate-spin" aria-hidden />}
      {children}
    </button>
  );
}
